/*
 * Embed Block
 * Show videos and social posts directly on your page
 * https://www.hlx.live/developer/block-collection/embed
 * Removed the twitter, youtube ..extend the below block for extension
 */
import './embed.css';

const getDefaultEmbed = (url, isScroll) => `<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;">
      <iframe src="${url.href}" style="border: 0; top: 0; left: 0; width: 100%; height: ${isScroll ? '700px' : '100%'}; position: absolute;" allowfullscreen=""
        scrolling="${isScroll ? 'yes' : 'no'}" allow="encrypted-media" title="Content from ${url.hostname}" loading="lazy">
      </iframe>
    </div>`;

const embedGoogleMaps = (url) => `<div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;">
      <iframe 
        src="${url.href}"
        class="embed-map-iframe"
        style="border: 0; top: 0; left: 0; width: 100%; height: 100%; position: absolute;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>`;

const loadEmbed = async (block, link, autoplay) => {
  if (block.classList.contains('embed-is-loaded')) {
    return;
  }
  const isScroll = block.classList.contains('with-scroll');
  const BLACKLIST_CONFIG = [
    {
      match: ['youtube', 'youtu.be'],
    },
  ];

  const blockedUrl = BLACKLIST_CONFIG.find((e) => e.match.some((match) => link.includes(match)));
  if (blockedUrl) {
    return;
  }

  const EMBEDS_CONFIG = [
    {
      match: ['google.com/maps', 'goo.gl/maps', 'maps.app.goo.gl'],
      embed: embedGoogleMaps,
    },
  ];

  const config = EMBEDS_CONFIG.find((e) => e.match.some((match) => link.includes(match)));
  const url = new URL(link);
  if (config) {
    block.innerHTML = config.embed(url, autoplay);
    block.classList.add(`embed-${config.match[0]}`);
  } else {
    block.innerHTML = getDefaultEmbed(url, isScroll);
  }
  block.classList.add('embed-is-loaded');
};

function addSkipLink(block) {
  block.insertAdjacentHTML(
    'afterbegin',
    '<a href="#after-map" class="skip-map-link">Skip Google Map</a>',
  );

  const afterMap = document.createElement('div');
  afterMap.id = 'after-map';
  afterMap.setAttribute('tabindex', '-1');

  block.appendChild(afterMap);
}

export default async function decorate(block) {
  const placeholder = block.querySelector('picture');
  const link = block.querySelector('a').href;
  block.textContent = '';
  if (placeholder) {
    const wrapper = document.createElement('div');
    wrapper.className = 'embed-placeholder';
    wrapper.innerHTML = '<div class="embed-placeholder-play"><button type="button" title="Play"></button></div>';
    wrapper.prepend(placeholder);
    wrapper.addEventListener('click', () => {
      loadEmbed(block, link, true);
      addSkipLink(block);
    });
    block.append(wrapper);
  } else {
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        observer.disconnect();
        loadEmbed(block, link);
        addSkipLink(block);
      }
    });
    observer.observe(block);
  }
}
